<template>
  <div>
    <div class="main_box">
      <div>
        <!--操作栏-->
        <el-form @submit.native.prevent :inline="true">
          <el-form-item>
            <el-form-item label="集中器UID：" prop="">
              <el-select
                v-model="searchForm.concentratorUid"
                placeholder="请选择"
                :filterable="true"
                :clearable="true"
                @change="changeConcentrator()"
                @clear="clearConcentrator"
              >
                <el-option
                  v-for="(item, index) in concentratorList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="插座号： " prop="">
              <el-select
                v-model="searchForm.socketNo"
                placeholder="请选择"
                :filterable="true"
                :clearable="true"
              >
                <el-option
                  v-for="(item, index) in socketInfo"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="扫码人员：" prop="">
              <el-input v-model="searchForm.userName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系方式：" prop="">
              <el-input v-model="searchForm.userMobile" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="充电时间" prop="">
              <el-date-picker
                v-model="searchForm.chargeDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="dateChange"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button type="danger" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main_box_table">
      <el-table :data="chargeData" border>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="concentratorUid" label="集中器UID"></el-table-column>
        <el-table-column prop="socketNo" label="插座号"></el-table-column>
        <el-table-column prop="userName" label="扫码人员"></el-table-column>
        <el-table-column prop="userMobile" label="联系方式 "></el-table-column>
        <el-table-column prop="time" label="充电时长"></el-table-column>
        <el-table-column prop="chargeDate" label="充电时间 "></el-table-column>
      </el-table>
      <div class="flex-r-e">
        <el-pagination
          v-show="total > 0"
          background=""
          layout="prev, pager, next, sizes, total, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
var _self;
export default {
  data() {
    return {
      //分页
      pageNum: 1,
      pageSize: 10,
      total: 0,
      statusList:[],
      searchForm: {
        concentratorUid: "",
        socketNo: "",
        userName: "",
        userMobile: "",
        chargeDate: "",
        startDate: "",
        endDate: ""
      },
      chargeData: [],
      concentratorList:[],
      socketInfo:[]
    };
  },

  created() {
    _self = this;
  },
  mounted() {
    _self.loadData();
    _self.getConcentratorList();
  },
  methods: {
    clearConcentrator() {
      _self.searchForm.concentratorUid = "";
      _self.searchForm.socketNo = "";
      _self.loadData();
    },
    dateChange() {
      if (_self.searchForm.chargeDate == null) _self.searchForm.chargeDate = [];
    },
    // 每页多少条
    handleSizeChange(val) {
      _self.pageSize = val;
      _self.loadData();
    },
    // 当前页
    handleCurrentChange(val) {
      _self.pageNum = val;
      _self.loadData();
    },
    loadData() {
      if(_self.searchForm.chargeDate.length>0){
        _self.searchForm.startDate =_self.searchForm.chargeDate[0];
        _self.searchForm.endDate = _self.searchForm.chargeDate[1];
      }
      let param = {
        pageNum: _self.pageNum - 1,
        pageSize: _self.pageSize,
        ..._self.searchForm
      };
      api.chargeAPI
        .getChargeList(param)
        .then(res => {
          if (res.status == 200) {
            if (res.data.content.length == 0 && res.data.total != 0) {
              _self.pageNum -= 1;
              _self.loadData();
              return;
            }
            _self.chargeData = res.data.content;
            _self.total = res.data.total;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    reset() {
      _self.searchForm = _self.$options.data().searchForm;
      _self.loadData();
    },
    exportData() {
      if(_self.searchForm.chargeDate.length>0){
        _self.searchForm.startDate =_self.searchForm.chargeDate[0];
        _self.searchForm.endDate = _self.searchForm.chargeDate[1];
      }
      let param = {
        ..._self.searchForm
      };
      api.chargeAPI
        .exportExcel(param)
        .then(res => {
          console.log(res,'ressss');
          // // 文件下载
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8"
          });
          const fileName = "充电记录.xlsx";

          /** 接收文件流 */
          let url = URL.createObjectURL(blob);
          /** 模拟浏览器操作Document，并模拟下载动作 */
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute(
            "download",
           fileName
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getConcentratorList() {
      let res = await api.deviceAPI.getConcentratorInfo();
      if(res.status==200){
        _self.concentratorList = res.data.map(it => {
          return {
            value: it.id,
            label: it.concentratorUid
          }
        })
      }
      console.log(res);
    },
    async changeConcentrator(){
      console.log(33333);
      let res = await api.deviceAPI.getSocketInfo({ id:_self.searchForm.concentratorUid });
      if(res.status==200) {
        _self.socketInfo = res.data.map(it => {
          return {
            value: it.id,
            label: it.socketNo
          }
        })
      }
      console.log(res,'3333333');
    }
  }
};
</script>
<style lang="scss" scoped></style>
